module.exports = __webpack_public_path__ + "img/capacitivos.088c0deb.jpg";